import { ContainerModule } from 'inversify'
import TYPES from 'config/inversify.types'
import { DashboardStore } from 'store/dashboard/dashboard.store'
import { DashboardServiceImpl } from './dashboard.service.impl'

export const DashboardModule = new ContainerModule((bind) => {
    bind(TYPES.DashboardService).to(DashboardServiceImpl).inSingletonScope()
    bind(TYPES.DashboardStore).to(DashboardStore).inSingletonScope()
})
